var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3636 0.63623H0.636353V33.3635H33.3636V0.63623ZM10.7931 13.05H2.89338V20.9497H10.7931V13.05ZM23.2069 13.05H31.1066V20.9497H23.2069V13.05ZM20.9498 13.05H13.0501V20.9497H20.9498V13.05Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareRow);
export default __webpack_public_path__ + "static/media/CompareRow.13d6b69a7fa353ccbd9cd97cfbcddb9b.svg";
export { ForwardRef as ReactComponent };